module.exports = "/_next/static/images/8cdf859878f39ba86e3a1afbd55fc96f-woman-with-sandwich@0.75x.jpg";